import $ from "jquery";
import {initWebComponent} from "@/helpers/web-component-helper";
import {clearLayer, getFeatureByKey, removeFeatureByKey, removeLayer} from "@/helpers/ol/ol-layer-helper";
import {
    geMeasureLayerName, geMeasureLayerStyle,
    generateMeasureLayers, getMeasureLayerStyleFunction, setActiveMeasureFeature,
    setActiveMeasureFeatureKey, setSegmentStyleVisible,
    toggleSegmentStyle
} from "@/helpers/tools/tools-measure-helper";
import {finishDrawing, startDraw, undoDrawGeometry} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import Swal from "sweetalert2";
import {
    getBySelector,
    hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {deselectFeature, selectFeature} from "@/modules/ol/service/ol-service-wfs";
import {removeAllDrawings} from "@/helpers/tools/tools-mutation-helper";
import {viewFit} from "@/helpers/ol/ol-view.js";
import {loadTemporaryLayerInfo} from "@/helpers/layer/temporary/temporary-layer-helper.js";

export class LayerInfoToolsMeasureComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
         <div class="card-body text-secondary p-3">
            <div class="row">
                <div class="col-6">
                    <layer-info-tools-measure-template></layer-info-tools-measure-template>
                </div>
                <div class="col-6">
                    <layer-info-tools-template></layer-info-tools-template>
                </div>
            </div>
            <div class="mt-2">
            </div>
            <hr>
            <div class="row d-none" id="divToolsMeasureToggleButtons">
                <div class="col mt-2">
                    <label class="switcher mr-1 w-100">
                        <input id="toggleSegments" checked="checked" type="checkbox" value="1" class="switcher-input">
                        <span class="switcher-indicator">
                          <span class="switcher-yes">
                            <span class="fa fa-draw-polygon"></span>
                          </span>
                          <span class="switcher-no">
                            <span class="fa fa-times"></span>
                          </span>
                        </span>
                        <div class="switcher-label">
                            <div class="input-group w-100">
                                Toon maatvoering in
                                <span class="input-group-append">
                                    <select id="slcSegmentsMeasureType" class="custom-select ml-1" style="font-size:12px;margin-top: -10px;" size="1">
                                        <option value="m">meter</option>
                                        <option value="km">kilometer</option>
                                    </select>
                                </span>
                            </div>
                        </div>
                  </label>
                </div>
                <div class="col mt-2">
                    <button data-type="remove" class="btn btn-outline-danger btn-sm btn-block text-transform-none" href="#">
                        <span class="fa fa-trash float-left mt-1" data-type="remove"></span> Verwijder alle tekeningen
                    </button>
                </div>
            </div>
            <div class="row d-none" id="divToolsMeasureDrawButtons">
                <div class="col mt-2">
                    <button data-type="save" class="btn btn-outline-secondary btn-sm btn-block text-transform-none" href="#">
                        <span data-type="save" class="fa fa-stop float-left mt-1"></span> Tekening afsluiten
                    </button>
                </div>
                <div class="col mt-2">
                    <button data-type="undo" class="btn btn-outline-secondary btn-sm btn-block text-transform-none" href="#">
                        <span data-type="undo" class="fa fa-undo float-left mt-1"></span> Laatste klik ongedaan maken
                    </button>
                </div>
            </div>
            <div id="divMeasureDrawings" class="mt-3">
            </div>
        </div>`;

        initWebComponent(this, template)

        window.measureFeatures = []

        setSegmentStyleVisible(true)

        this.querySelector('#toggleSegments').addEventListener('change', () => {
            toggleSegmentStyle()
        })
      this.querySelector('#slcSegmentsMeasureType').addEventListener('change', () => {
            toggleSegmentStyle()
            toggleSegmentStyle()
        })

        this.querySelectorAll('button').forEach(element => {
            element.addEventListener('click', (evt) => {
                switch (evt.target.dataset.type) {
                    case 'save':
                        finishDrawing()
                        break
                    case 'undo':
                        undoDrawGeometry()
                        break;
                    case 'remove':
                        removeAllDrawings()
                        break;
                }
            })
        })

        this.querySelector('#divMeasureDrawings').addEventListener('click', (e) => {

            const element  = e.target.closest('.media')
            if(e.target.dataset.type ) {

                const feature = getFeatureByKey(window.drawMeasureVectorSource, element.dataset.featureKey)

                switch (e.target.dataset.type) {
                    case 'expand':
                        viewFit(feature.getGeometry(), undefined, undefined, undefined, true)
                        break;
                    case 'info':
                        loadTemporaryLayerInfo(window.drawMeasureVectorLayer, feature)
                        break;
                    case 'remove':
                        removeFeatureByKey(window.drawMeasureVectorSource, element.dataset.featureKey)
                        setActiveMeasureFeatureKey(undefined)
                        generateMeasureLayers(true)

                        window.measureFeatures.splice(element.dataset.featureKey, 1)
                        window.measurePrintFeatures.splice(element.dataset.featureKey, 1)

                        break;
                }
            } else {
                if(element && !element.classList.contains('active')) {
                    setActiveMeasureFeature(element, true)
                } else {
                    removeClassBySelector('#divMeasureDrawings .media', 'active')
                    setActiveMeasureFeatureKey(undefined)
                    deselectFeature()
                }
            }

        })
    }
}

